export default __webpack_public_path__ + "static/media/guesty_lite_step6.9e11fdbb.png";